import $ from 'jquery';
import moment from 'moment';
import { EventEmitter } from 'events';

/*
 * Hack for fullcalendar to replace getClientRect by getOuterRect in the queryBoundingRect function
 */
(function ($) {
  function getScrollParent(el) {
    const position = el.css('position');
    const scrollParent = el.parents().filter(function () {
      const parent = $(this);
      return (/(auto|scroll)/).test(
        parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x')
      );
    }).eq(0);
    return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
  }
  const getOuterRect = $.fullCalendar.getOuterRect;
  const coordCache = {
    queryBoundingRect() {
      const scrollParentEl = getScrollParent(this.els.eq(0));
      if (!scrollParentEl.is(document)) {
        return getOuterRect(scrollParentEl);
      }
      return undefined;
    },
  };
  $.extend($.fullCalendar.CoordCache.prototype, coordCache);

  /*
   * Hack for resetting a modal form
   * Hack for showing time on hover side by side
   * TODO: try to avoid it
   */
  $(document).on('opened', '.remodal', () => {
    EventEmitter.prototype.emit('modal-opened');

    // Add custom css to prevent scrolling on iOs
    $('html').addClass('has-modal');
  }).on('closed', '.remodal', () => {
    EventEmitter.prototype.emit('modal-closed');

    // Remove custom css to prevent scrolling on iOs
    $('html').removeClass('has-modal');
  }).on('mouseenter', '.c-calendar-dayview--notimeaxis .fc-slats tr', (e) => {
    const time = moment($(e.currentTarget).attr('data-time'), 'hh:mm:ss').format('h:mm A');
    $(e.currentTarget.children[1]).text(time);
  }).on('mouseleave', '.c-calendar-dayview--notimeaxis .fc-slats tr', (e) => {
    $(e.currentTarget.children[1]).text('');
  });

  /*
   * Removing a loader
   */
  $('.js-main-loader').remove();
}($));
